import React, { Component } from 'react';
import ReactEcharts from 'react-echarts-component';
import { color } from 'echarts/lib/export';

export default class StackupCardItem extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }

        // this.calcPercentileFromZscore = this.calcPercentileFromZscore.bind(this);
        this.numberWithCommas = this.numberWithCommas.bind(this);
        this.convertToDisplay = this.convertToDisplay.bind(this);
        this.formatQuartileDisplay = this.formatQuartileDisplay.bind(this);


        this.showPopup = this.showPopup.bind(this);

        this.generateBottomContent = this.generateBottomContent.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    numberWithCommas(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    convertToDisplay(type, number) {

        let endText = '';
        switch (type) {
            case 'MNY':
                endText += '$' + this.numberWithCommas(number);
                break;
            case 'INT':
                let newNum = parseFloat(number);
                if (newNum === NaN) {
                    endText += '';
                } else {
                    endText += this.numberWithCommas(parseFloat(number).toFixed(0));
                }
                break;
            case 'PCT':
                let newNum1 = parseFloat(number);
                if (newNum1 === NaN) {
                    endText += '';
                } else {
                    endText += this.numberWithCommas(parseFloat(number).toFixed(1)) + '%';
                }
                break;
            default:
                endText += this.numberWithCommas(number);
        }
        return endText;
    }

    formatQuartileDisplay(num, type) {
        let result = "0";

        if (num / 1000000 >= 1) {
            result = (num / 1000000.0).toFixed(1) + "M";
        } else if (num / 1000 >= 1) {
            result = (num / 1000.0).toFixed(1) + "K";
        } else {
            result = num.toFixed(1);
        }

        if (type === 'MNY') { result = "$" + result; }
        if (type === 'PCT') { result = result + "%"; }

        return result;
    }

    showPopup() {
        let identity = this.props.identity;
        let tmpData = this.props.data;

        let q1 = this.formatQuartileDisplay(tmpData.bottomQuarter, identity.type);
        let h = this.formatQuartileDisplay(tmpData.half, identity.type);
        let q3 = this.formatQuartileDisplay(tmpData.topQuarter, identity.type);

        let displayNums = ["Below", q1, h, q3, "Above"];
        if (this.props.masterKpiList[identity.masterKpiId].isNegativeSlope) {
            displayNums.reverse();
        }

        let descriptionText = this.props.masterKpiList[identity.masterKpiId].description;

        alert((
            <div className={"stackup-popup-outer"}>
                <div className={"kpi-name"}>{identity.name}</div>
                <div className={"kpi-description"}>{descriptionText}</div>
                <div className={"quartile-container"}>
                    <div className={"quartile"}>
                        <div className={"circle-container"}>
                            <div className={"circle-actual q4"}></div>
                        </div>
                        <div className={"quartile-range"}>{"Q4: " + displayNums[4] + " " + displayNums[3]}</div>
                    </div>
                </div>
                <div className={"quartile-container"}>
                    <div className={"quartile"}>
                        <div className={"circle-container"}>
                            <div className={"circle-actual q3"}>
                                <div className={"tl"}></div>
                            </div>
                        </div>
                        <div className={"quartile-range"}>{"Q3: " + displayNums[2] + " - " + displayNums[3]}</div>
                    </div>
                </div>
                <div className={"quartile-container"}>
                    <div className={"quartile"}>
                        <div className={"circle-container"}>
                            <div className={"circle-actual q2"}>
                                <div className={"tl"}></div>
                                <div className={"bl"}></div>
                            </div>
                        </div>
                        <div className={"quartile-range"}>{"Q2: " + displayNums[1] + " - " + displayNums[2]}</div>
                    </div>
                </div>
                <div className={"quartile-container"}>
                    <div className={"quartile"}>
                        <div className={"circle-container"}>
                            <div className={"circle-actual q1"}>
                                <div className={"tl"}></div>
                                <div className={"bl"}></div>
                                <div className={"br"}></div>
                            </div>
                        </div>
                        <div className={"quartile-range"}>{"Q1: " + displayNums[0] + " " + displayNums[1]}</div>
                    </div>
                </div>
            </div>
        ));
    }

    generateBottomContent() {
        let identity = this.props.identity;
        let tmpData = this.props.data;

        let min = this.formatQuartileDisplay(tmpData.min, identity.type);
        let q1 = this.formatQuartileDisplay(tmpData.bottomQuarter, identity.type);
        let h = this.formatQuartileDisplay(tmpData.half, identity.type);
        let q3 = this.formatQuartileDisplay(tmpData.topQuarter, identity.type);
        let max = this.formatQuartileDisplay(tmpData.max, identity.type);

        let displayNums = [min, q1, h, q3, max];
        if (this.props.masterKpiList[identity.masterKpiId].isNegativeSlope) {
            displayNums.reverse();
        }

        return (
            <div className={"stackup-card-bottom-container"} onClick={this.showPopup}>
                <div className={"color-bar"}>
                    <div className={"color-item"}>
                        <div className={"num-display"}>{/*displayNums[0]*/}</div>
                    </div>
                    <div className={"color-item"}>
                        <div className={"num-display"}>{displayNums[1]}</div>
                    </div>
                    <div className={"color-item"}>
                        <div className={"num-display"}>{displayNums[2]}</div>
                    </div>
                    <div className={"color-item"}>
                        <div className={"num-display"}>{displayNums[3]}</div>
                        <div className={"num-display"}>{/*displayNums[4]*/}</div>
                    </div>
                </div>
            </div>
        );
    }

    render() {

        let identity = this.props.identity;

        let bottomJsx = this.generateBottomContent();

        return (
            <div className={"stackup-card-item-outer"}>
                <div className="stackup-card-item-icon-container">
                    <div className="material-icons stackup-card-item-icon">{"layers"}</div>
                </div>
                <div className="stackup-card-name-container wide" onClick={this.showPopup}>
                    <div className="stackup-card-name">{identity.name}</div>
                </div>
                {bottomJsx}
            </div>
        );
    }
}